import React from "react";

const CloningDisabled = ({ width = 22, height = 17, fill = "#BBBBBB" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="14.0918"
      cy="7.93173"
      r="6.67136"
      stroke={fill}
      stroke-width="2.46972"
    />
    <circle
      cx="7.97458"
      cy="8.11899"
      r="7.28879"
      fill={fill}
      stroke={fill}
      stroke-width="1.23486"
    />
    <g clip-path="url(#clip0_2151_21288)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.89429 9.42018L6.08906 11.2254C5.80253 11.5119 5.33793 11.5121 5.05148 11.2257L4.70561 10.8798C4.41916 10.5934 4.41934 10.1288 4.70588 9.84222L6.51111 8.03699L4.70707 6.23295C4.42062 5.94651 4.4208 5.48191 4.70734 5.19537L5.05345 4.84926C5.33998 4.56273 5.80458 4.56255 6.09103 4.84899L7.89507 6.65303L9.7003 4.8478C9.98684 4.56127 10.4514 4.56109 10.7379 4.84753L11.0838 5.1934C11.3702 5.47985 11.37 5.94445 11.0835 6.23099L9.27826 8.03622L11.0823 9.84026C11.3687 10.1267 11.3686 10.5913 11.082 10.8778L10.7359 11.224C10.4494 11.5105 9.98478 11.5107 9.69833 11.2242L7.89429 9.42018Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2151_21288">
        <rect
          width="7.8251"
          height="7.8251"
          fill="white"
          transform="translate(3.98047 4.1261)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default CloningDisabled;
